import { HttpClient } from  '@angular/common/http';
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs/index";
import {BusinessOwnerDto} from "../../model/business/dto/business-owner-dto";
import {AuthHttp} from "angular2-jwt";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class BusinessOwnerService {

  constructor(private authHttp: AuthHttp,
              private http: HttpClient) {
  }

  public createBusinessOwner(businessOwnerDto: BusinessOwnerDto): Observable<any> {
    return this.http.post(environment.BACKEND_ROOT_SERVICE + "details/add", businessOwnerDto);
  }

  public getBusinessOwner(): Observable<any> {
    return this.authHttp.get(environment.BACKEND_ROOT_SERVICE + "details");
  }

  public updateBusinessOwner(businessOwnerDto: BusinessOwnerDto): Observable<any> {
    return this.authHttp.put(environment.BACKEND_ROOT_SERVICE + "details", businessOwnerDto);
  }

  public updateOwnerPhone(phoneNo: string) {
    return this.authHttp.put(environment.BACKEND_ROOT_SERVICE + "profile/change-phone?phoneNo=" +
      encodeURIComponent(phoneNo), null);
  }

  public updateOwnerPassword(newPassword: string, oldPassword: string) {
    return this.authHttp.put(environment.BACKEND_ROOT_SERVICE + "profile/change-password?password=" + newPassword, null);
  }
}
